var _title, _g;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgAtm = function SvgAtm(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 20 15",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "Card Copy 10")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "4.4.1-Wallet-Top-Up",
    transform: "translate(-34.000000, -744.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Card-Copy-10",
    transform: "translate(32.000000, 739.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(3.000000, 6.000000)",
    stroke: "#000000de",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.88686555,7.71428571 L1,7.71428571 C0.44771525,7.71428571 6.76353751e-17,7.26657046 0,6.71428571 L0,1 C-6.76353751e-17,0.44771525 0.44771525,1.01453063e-16 1,0 L17,0 C17.5522847,-1.01453063e-16 18,0.44771525 18,1 L18,6.71428571 C18,7.26657046 17.5522847,7.71428571 17,7.71428571 L16.0257126,7.71428571 L16.0257126,7.71428571",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1142857,5.14285714 L14.1142857,11.3428571 C14.1142857,11.8951419 13.6665705,12.3428571 13.1142857,12.3428571 L5.11428571,12.3428571 C4.56200096,12.3428571 4.11428571,11.8951419 4.11428571,11.3428571 L4.11428571,5.14285714 L4.11428571,5.14285714",
    id: "Path",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.2,5.14285714 C7.2,6.13696969 8.00588745,6.94285714 9,6.94285714 C9.99411255,6.94285714 10.8,6.13696969 10.8,5.14285714",
    id: "Path",
    strokeLinecap: "round"
  })))))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAtm, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/atm.3f2a1768.svg";
export { ForwardRef as ReactComponent };